import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import { Tabs, Tab, AppBar, Typography, Box, InputBase } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from "../../../../assets/img/svg/Del.svg"
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import { putDMS, deleteDMS } from "../../../../actions/DMSAction";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import moment from "moment";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class EditOPA extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            value: 0,
            DeleteData: [],
            isView: false,
            VesselManHours: false,
            YardManHours: false,
            cancel: false,
            Error: {
                DateofReportingError: false,
                VesselManpowerError: false,
                YardManpowerError: false,
                YardManpowerHoursError: false,
                VesselManpowerHoursError: false,
            },
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "DateOfReporting": "",
                "VesselManpower": "",
                "YardManpower": "",
                "VesselManpowerHours": "",
                "YardManpowerHours": "",
                "YardComments": "",
                "VesselComments": ""
            }
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("DMSEditId"))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.getSettingsFormat(parseInt(localStorage.getItem("DashId")))
        this.geteditdmsinfo(this.state.addData.Id)
        let tempdata = {
            data: parseInt(localStorage.getItem("DMSEditId"))
        }
        this.state.DeleteData.push(tempdata)
        this.state.ProjectId = localStorage.getItem("DashId");
        this.setState({})

        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getSettingsFormat = (data) => {
        let apiUrl = API.SETTINGS_PROJECT + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#MAN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dailyman1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Dailyman").addClass("d-none");
        $("#Dailyman").removeClass("d-block");
        $("#DMPSL").removeClass("active-color");
        $("#DMPST").removeClass("fw-bolder");
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
    };
    geteditdmsinfo = (id) => {
        let apiUrl = API.DMS_LISTVIEW + '/' + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "DMSEDIT_DOCS", data: response.data });
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.DateOfReporting = response.data.DateOfReporting;
                    this.state.addData.VesselManpower = response.data.VesselManpower;
                    this.state.addData.YardManpower = response.data.YardManpower;
                    this.state.addData.YardManpowerHours = response.data.YardManpowerHours;
                    this.state.addData.VesselManpowerHours = response.data.VesselManpowerHours;
                    this.state.addData.YardComments = response.data.YardComments;
                    this.state.addData.VesselComments = response.data.VesselComments;
                    this.setState({})
                    if (this.state.addData.VesselManpowerHours != "" && this.state.addData.VesselManpower != '') {
                        if (this.state.addData.VesselManpowerHours > (this.state.addData.VesselManpower * 10)) {
                            this.setState({
                                VesselManHours: true
                            })
                        }
                        else {
                            this.setState({
                                VesselManHours: false
                            })
                        }
                    }

                    if (this.state.addData.YardManpowerHours != "" && this.state.addData.YardManpower != '') {
                        if (this.state.addData.YardManpowerHours > (this.state.addData.YardManpower * 10)) {
                            this.setState({
                                YardManHours: true
                            })
                        }
                        else {
                            this.setState({
                                YardManHours: false
                            })
                        }
                    }
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#MAN1 .MuiListItemText-primary").addClass("spanTopBar");

        $("#Dailyman1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dailyman").removeClass("d-none");
        $("#Dailyman").addClass("d-block");
        $("#DMPSL").addClass("active-color");
        $("#DMPST").addClass("fw-bolder");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("DMSEditId"))
        this.setState({})

    };
    DeleteItem = () => {
        this.state.addData.Id = parseInt(localStorage.getItem("DMSEditId"))
        this.deleteDMS(this.state.addData.Id)
    }
    deleteDMS = (id) => {
        let apiUrl = API.DMS_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/dailymanpowerstatus")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    handleInputChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.value == "") {
            this.state.addData[node] = "";
        }
        else {
            this.state.addData[node] = parseInt(e.target.value);
        }
        this.setState({});
        if ((this.state.addData.VesselManpowerHours != "" || this.state.addData.VesselManpowerHours == 0) && (this.state.addData.VesselManpowerHours != '' || this.state.addData.VesselManpowerHours == 0)) {
            if (this.state.addData.VesselManpowerHours > (this.state.addData.VesselManpower * 10)) {
                this.setState({
                    VesselManHours: true
                })
            }
            else {
                this.setState({
                    VesselManHours: false
                })
            }
        }

        if ((this.state.addData.YardManpowerHours != "" || this.state.addData.YardManpowerHours == 0) && (this.state.addData.YardManpower != '' || this.state.addData.YardManpower == 0)) {
            if (this.state.addData.YardManpowerHours > (this.state.addData.YardManpower * 10)) {
                this.setState({
                    YardManHours: true
                })
            }
            else {
                this.setState({
                    YardManHours: false
                })
            }
        }
    };

    handleDateChange = (e, str) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[str] = e.target.value;
        this.setState({})
    };

    handleCommendChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node === "VesselComments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData.VesselComments = e.target.value;
            }
        } else if (node === "YardComments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData.YardComments = e.target.value;
            }
        }
        this.setState({});
    };
    EditCancel = () => {
        if (this.state.value == 1) {
            this.state.value = 0
            this.setState({})
            this.geteditdmsinfo(this.state.addData.Id)
        }
        else {
            if (this.state.cancel == true) {
                window.$("#cancelpopup").modal("show");
            } else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate("/dailymanpowerstatus")
            }
        }
    };

    EditCancel1 = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/dailymanpowerstatus")
    }
    EditSave = () => {
        if (this.state.addData.DateOfReporting === "") {
            this.state.Error.DateofReportingError = true;
            this.setState({})
        }
        else {
            this.state.Error.DateofReportingError = false;
            this.setState({})
        }
        if (this.state.addData.VesselManpower === "") {
            this.state.Error.VesselManpowerError = true;
            this.setState({})
        }
        else {
            this.state.Error.VesselManpowerError = false;
            this.setState({})
        }
        if (this.state.addData.YardManpower === "") {
            this.state.Error.YardManpowerError = true;
            this.setState({})
        }
        else {
            this.state.Error.YardManpowerError = false;
            this.setState({})
        }
        if (this.state.addData.VesselManpowerHours === "") {
            this.state.Error.VesselManpowerHoursError = true;
            this.setState({})
        }
        else {
            this.state.Error.VesselManpowerHoursError = false;
            this.setState({})
        }
        if (this.state.addData.YardManpowerHours == '') {
            this.state.Error.YardManpowerHoursError = true;
            this.setState({})
        }
        else {
            this.state.Error.YardManpowerHoursError = false;
            this.setState({})

        }
        if (this.state.addData.DateOfReporting !== '' && this.state.addData.VesselManpower !== "" && this.state.addData.YardManpower !== "" && this.state.addData.VesselManpowerHours !== "" && this.state.addData.YardManpowerHours != '') {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.addData.VesselComments != null) {
                this.state.addData.VesselComments = this.state.addData.VesselComments.trim();
                this.setState({})
            }
            if (this.state.addData.YardComments != null) {
                this.state.addData.YardComments = this.state.addData.YardComments.trim();
                this.setState({})
            }
            this.putDMS(this.state.addData, this.state.addData.Id)
        }
        else {
        }
    }
    putDMS = (data, id) => {
        let apiUrl = API.DMS_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/dailymanpowerstatus")
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"MAN" + "1"} className='pl-3 textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="MAN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Daily Manpower Status</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel}></i></td>
                                    <td className="border-right text-center">
                                        <button className={classes.button} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                    </td>
                                    <td className="border-right text-center">
                                        <button className={`${classes.button} pl-3`} onClick={this.EditCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                    <td className="border-right text-center">
                                        <button className={`${classes.button} pl-3`} data-target="#deletepopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} pl-3`} onClick={this.EditCancel} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        <button className={`${classes.button} pl-3`} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? this.state.VesselManHours || this.state.YardManHours ? <>
                            <div className="col-12 mx-2 mt-3 ml-1">
                                <button className={classes.Overtime}><h1 style={{ fontSize: '11px' }}>Overtime Exceeds</h1></button>
                            </div>
                        </> : <></>
                            :
                            <h6 className="col-12 mx-2 mt-3 ml-1">Edit Manpower Status  {this.state.VesselManHours || this.state.YardManHours ? <>
                                <button className={classes.Overtime}><h1 style={{ fontSize: '11px' }}>Overtime Exceeds</h1></button>
                            </> : <></>}</h6>}
                        {/* {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">Edit Daily Manpower Status</h6>} */}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex m-0"}>Date of Reporting&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    {this.state.Error.DateofReportingError ?
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            id="type-date"
                                            value={this.state.addData.DateOfReporting && moment(this.state.addData.DateOfReporting).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.DateOfReporting && moment(this.state.addData.DateOfReporting).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleDateChange(e, "DateOfReporting") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                        :
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            id="type-date"
                                            value={this.state.addData.DateOfReporting && moment(this.state.addData.DateOfReporting).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.DateOfReporting && moment(this.state.addData.DateOfReporting).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleDateChange(e, "DateOfReporting") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex m-0"}>Vessel Manpower&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    {this.state.Error.VesselManpowerError ?
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            placeholder="0"
                                            value={this.state.addData.VesselManpower}
                                            onChange={(e) => { this.handleInputChange(e, "VesselManpower") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            placeholder="0"
                                            value={this.state.addData.VesselManpower}
                                            onChange={(e) => { this.handleInputChange(e, "VesselManpower") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex m-0"}>Vessel Man Hours&nbsp;:
                                    <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                    </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    {this.state.Error.VesselManpowerHoursError ?
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            placeholder="0"
                                            value={this.state.addData.VesselManpowerHours}
                                            onChange={(e) => { this.handleInputChange(e, "VesselManpowerHours") }}

                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            placeholder="0"
                                            value={this.state.addData.VesselManpowerHours}
                                            onChange={(e) => { this.handleInputChange(e, "VesselManpowerHours") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                            {this.state.VesselManHours ? <>
                                <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 "}`}>
                                        <label className={this.state.isMobile ? "pt-2" : "m-0 d-flex float-end text-right"}>Comments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                        <TextField
                                            multiline
                                            rows={8}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.VesselComments}
                                            onChange={(e) => { this.handleCommendChange(e, "VesselComments") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.VesselComments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.VesselComments?.length}/1000 Characters left</label>
                                    </div>
                                </div></> : <></>}
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex m-0"}>Yard Manpower&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    {this.state.Error.YardManpowerError ?
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            placeholder="0"
                                            value={this.state.addData.YardManpower}
                                            onChange={(e) => { this.handleInputChange(e, "YardManpower") }}

                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            placeholder="0"
                                            value={this.state.addData.YardManpower}
                                            onChange={(e) => { this.handleInputChange(e, "YardManpower") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex m-0"}>Yard Man Hours&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    {this.state.Error.YardManpowerHoursError ?
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            placeholder="0"
                                            value={this.state.addData.YardManpowerHours}
                                            onChange={(e) => { this.handleInputChange(e, "YardManpowerHours") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            placeholder="0"
                                            value={this.state.addData.YardManpowerHours}
                                            onChange={(e) => { this.handleInputChange(e, "YardManpowerHours") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            {this.state.YardManHours ? <>
                                <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 "}`}>
                                        <label className={this.state.isMobile ? "pt-2" : "m-0 d-flex float-end text-right"}>Comments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                        <TextField
                                            multiline
                                            rows={8}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.YardComments}
                                            onChange={(e) => { this.handleCommendChange(e, "YardComments") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.YardComments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.YardComments?.length}/1000 Characters left</label>
                                    </div>
                                </div></> : <></>}
                        </div>
                        {/* <div className="row mx-1 px-3 mt-3">
                            <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-top"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex"}>Date of Reporting&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>                        </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    {this.state.Error.DateofReportingError ?
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            id="type-date"
                                            value={this.state.addData.DateOfReporting && moment(this.state.addData.DateOfReporting).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleDateChange(e, "DateOfReporting") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}

                                        />
                                        :
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.DateOfReporting && moment(this.state.addData.DateOfReporting).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleDateChange(e, "DateOfReporting") }}
                                            id="type-date"
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex"}>Vessel Manpower&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>                        </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    {this.state.Error.VesselManpowerError ?
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.VesselManpower}
                                            onChange={(e) => { this.handleInputChange(e, "VesselManpower") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}

                                        />
                                        :
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.VesselManpower}
                                            onChange={(e) => { this.handleInputChange(e, "VesselManpower") }}

                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "" : "m-0 d-flex"}>VesselMan Hours&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    {this.state.Error.VesselManpowerHoursError ?
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            placeholder="0"
                                            value={this.state.addData.VesselManpowerHours}
                                            onChange={(e) => { this.handleInputChange(e, "VesselManpowerHours") }}

                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            placeholder="0"
                                            value={this.state.addData.VesselManpowerHours}
                                            onChange={(e) => { this.handleInputChange(e, "VesselManpowerHours") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                            {this.state.VesselManHours ? <>
                                <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-top"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                        <label className={this.state.isMobile ? "pt-2" : "m-0 d-flex"}>Comments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                        <TextField
                                            multiline
                                            rows={8}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.VesselComments}
                                            onChange={(e) => { this.handleCommendChange(e, "VesselComments") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.VesselComments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.VesselComments?.length}/1000 Characters left</label>

                                    </div>
                                </div></> : <></>}
                            <div className={`row  mx-1 align-items-center  ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex"}>Yard Manpower&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>                              </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    {this.state.Error.YardManpowerError ?
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.YardManpower}
                                            onChange={(e) => { this.handleInputChange(e, "YardManpower") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.YardManpower}
                                            onChange={(e) => { this.handleInputChange(e, "YardManpower") }}

                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "mt-2" : "m-0 d-flex"}>Yard Man Hours&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    <TextField
                                        type="number"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        placeholder="0"
                                        value={this.state.addData.YardManpowerHours}
                                        onChange={(e) => { this.handleInputChange(e, "YardManpowerHours") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                            {this.state.YardManHours ? <>
                                <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                        <label className={this.state.isMobile ? "pt-2" : "m-0 d-flex"}>Comments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>                                        <TextField
                                        multiline
                                        rows={8}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.YardComments}
                                        onChange={(e) => { this.handleCommendChange(e, "YardComments") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.YardComments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.YardComments?.length}/1000 Characters left</label>

                                    </div>
                                </div></> : <></>}

                        </div> */}
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5>
                                    </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel1}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        shareddmsdata: state.DMSReducer.shareddmsdata || [],
        errordmspass: state.DMSReducer.errordmspass || [],
        settings: state.commonReducer.settings || [],
    };
}

EditOPA.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditOPA))
);

